import React, { useState, useEffect, useRef } from "react";
import { MSG } from "../constants/toastMessages";
import { IoCloseOutline } from "react-icons/io5";
import { toast } from 'react-toastify';
import { apiCallingPost } from "../api/services"

function TagDirectoryEdit(props) {

  const [selectTagList, setSelectTagList] = useState([]);
  const [selectAllFlag, setSelectAllFlag] = useState(false)
  useEffect(() => {
    if (props.findTagFlag){
      document.getElementById("findTagName").focus()

    }
    if (props.videoDetails.length > 0) {
      setSelectAllFlag(true)
      setSelectTagList(props.videoDetails?.[0]?.reletedTags)
    }
    else {
      setSelectAllFlag(false)
    }
  }, [props.videoDetails]);
  const UpdateDirectory = async () => {

    if (!selectAllFlag && selectTagList.length === 0) {
      toast.warn(MSG.selectTagsToReplace)
      return
    }
    if (!props.updateTag) {
      toast.warn(MSG.replaceTagNameRequired)
      return
    }
    if (props.findTagFlag && (props.findTag == props.updateTag)) {
      toast.warn(MSG.noChangesMade)
      return
    }

    let postData = {
      tag: props.findTag || props.videoDetails?.[0]?.tag_name,
      new_tag: props.updateTag,
      selected_tag: selectTagList,
      type: (props.findTagFlag ? (selectAllFlag ? "replaceall" : "selected_replace") : "replace")
    }

    try {
      const response = await apiCallingPost("api/tag_directory/update_tags", postData);
      const { data } = response;
      if (data.success === "1") {
        toast.success(MSG.tagUpdated);
        setTimeout(() => {
          props.TagDirectoryList()
          props.cancelPopup()
        }, 1000);
      }
    } catch (error) {
      console.error("Error fetching tag directory:", error);
    }
  }
  const selectIds = (tagName) => {
    if (!selectAllFlag) {
      setSelectTagList((prev) => {
        if (prev.includes(tagName)) {
          return prev.filter(tag => tag !== tagName)
        } else {
          return [...prev, tagName]
        }
      })
    }
  }
  const checkboxOncahange = (e) => {
    const check = e.target.checked
    setSelectAllFlag(check)
    if (check) {

      setSelectTagList(props.videoDetails?.[0]?.reletedTags)
      // setTimeout(() => {
      // selectTagList.push(props.videoDetails?.[0]?.reletedTags)          
      // }, 1500);

    }
    else {
      setSelectTagList([])
    }
  }
  return (

    <div className="modal-admin-wrapper">

      <div className="modal-ad-popup modal-md" ref={props.wrapperRef}>
        <div className="modal-innerpopup ">
          <div className="modal-headdiv d-flex justify-content-between">
            <h5 className="modal-head">  Edit Tag</h5>
            <span className="closeBtn"><IoCloseOutline size={32} onClick={() => props.cancelPopup()} /></span>

          </div>
          <div className="form_div">

            <>
              <div className="d-flex align-items-center gap-2">
                {props.findTagFlag &&
                  <input type="text" placeholder="Find Tag Name"
                    className="form-register-popup" id = "findTagName"
                    style={{ resize: 'none' }}
                    value={props.findTag}
                    onChange={(e) => {
                      props.setFindTag(e.target.value)
                      if (e.target.value.length > 3) {
                        props.TagVideoDetails([e.target.value])
                      }
                      else {
                        props.TagVideoDetails([""])
                      }
                    }}
                  />
                }
                <input type="text"
                  className="form-register-popup"
                  style={{ resize: 'none' }}
                  value={props.updateTag}
                  placeholder={props.findTagFlag ? `Replace Tag Name` : `Update Tag Name`}
                  onChange={(e) => props.setUpdateTag(e.target.value)}
                />

              </div>
              {((props.findTagFlag && props.updateTag.length >= 3) || props.videoDetails?.[0]?.tag_name) && props.videoDetails?.[0].reletedTags.length > 0 &&
                <div className="text-center mb-3">Warning: Modifying the <strong>{props.videoDetails?.[0]?.tag_name ? props.videoDetails[0].tag_name : "tag(s)"}</strong> will affect the related tags and associated media files:</div>
              }
            </>

          </div>

          <div className="modal-admin-body" style={{ maxHeight: 'calc(100vh - 290px)' }}>
            <div className="col-12">
              <div className="form_div">


                {((props.findTagFlag && props.updateTag.length >= 3) || props.videoDetails?.[0]?.tag_name) &&
                  <>
                    {/* <div className="text-center mb-3">Warning: Modifying the <strong>{props.videoDetails?.[0]?.tag_name ? props.videoDetails[0].tag_name : "tag(s)"}</strong> will affect the related tags and associated media files:</div> */}

                    {props.findTagFlag &&

                      props.videoDetails?.[0]?.reletedTags.length > 0 &&
                      <>
                        <div className="checkbox-wrapper-1 d-flex align-items-center gap-2 justify-content-center">

                          <input id={`selectAllCheck`} className="substituted" type="checkbox" aria-hidden="true"
                            checked={selectAllFlag}
                            onChange={(e) => checkboxOncahange(e)}
                          />
                          <label className=" d-flex align-items-center" htmlFor={`selectAllCheck`}>Select all</label>
                          {/* <label></label> */}
                        </div>
                        <div className="text-center mb-2"><strong>Related tags</strong></div>
                        <div className="tag-listing tag-listing-popup mb-3">
                          {props.videoDetails?.[0]?.reletedTags.map((tag, index) => (
                            <div key={index} className={`tag-list ${(selectTagList.includes(tag) || selectAllFlag) ? 'selected' : ``}`} onClick={() => selectIds(tag)}>
                              {tag}
                            </div>
                          ))}
                        </div>
                      </>
                    }
                    {props.videoDetails?.[0]?.videonames.length > 0 &&
                      <>
                        <div className="text-center mb-2"><strong>Related Videos</strong></div>
                        <div className="tag-listing tag-listing-popup mb-3">
                          {props.videoDetails?.[0]?.videonames.map((video, index) => (
                            <div key={index} className="tag-list">
                              {video}
                            </div>
                          ))}
                        </div>
                      </>
                    }
                  </>
                }
              </div>
            </div>
          </div>
          <div className="tag-popup-footer">
            <div className="text-center mb-3">Do you want to proceed?</div>
            <div className="d-flex align-items-center gap-2">
              <button
                type="button"
                className="accept-all-btn w-100 py-2 accept-all-gray"
                onClick={() => props.cancelPopup()}
              >
                Cancel
              </button>
              <button
                disabled={props.videoDetails?.[0]?.reletedTags.length > 0 ? false : true}
                type="button"
                className="accept-all-btn w-100 py-2"
                onClick={() => UpdateDirectory()}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TagDirectoryEdit;